<template>
  <div class="detail-main">
    <div class="detail-name">{{keyword}}</div>
    <div class="detail-charts">
      <div class="dc-left">
        <div class="detail-title">
          <img src="./title.png" alt="" /> 立项数/资助金额趋势图
        </div>
        <div class="dc-main" id="dcmain1"></div>
      </div>
      <div class="dc-right">
        <div class="detail-title">
          <img src="./title.png" alt="" /> 相关申报领域立项趋势
        </div>
        <div class="dc-main" id="dcmain2"></div>
      </div>
    </div>
    <div class="detail-ly">
      <div class="detail-title">
          <img src="./title.png" alt="" /> 相关项目明细
      </div>
      <div class="detail-ly-wrap">
        <div class="detail-ly-item" v-for="i in metadata" :key="i.category_identifier">
        <div class="dli-title">{{i.category_identifier}}  {{i.foundation}}</div>
        <div class="dli-project" v-for="item in i.projects" :key="item.title">
          <div class="dlip-title">{{item.title}}</div>
          <div class="dlip-span">
            <span>立项人</span>
            {{item.projectAdmin}}
          </div>
          <div class="dlip-span">
            <span>依托单位</span>
            {{item.dependUnit}}
          </div>
          <div class="dlip-span">
            <span>申报年份</span>
            {{item.approvalYear}}
          </div>
          <div class="dlip-span">
            <span>资助金额</span>
            {{item.supportNum}}万元
          </div>
          <div class="dlip-span-key" v-if="item.keyword.length>0">
            <span>关键词</span>
            <span v-for="(ii,index) in item.keyword" :key="index">{{ii}}</span>
          </div>
        </div>
        
       
      </div>
      </div>
      
      <div class="dl-btn" v-if="!ismorely"> <el-button @click="morely">更多...</el-button></div>
    </div>
    <div class="detail-paper">
      <div class="detail-title">
          <img src="./title.png" alt="" /> 相关论文明细
      </div>
      <div class="detail-paperitem" v-for="i in paperlist" :key='i.title'>
        <div class="dp-title">{{i.title}}</div>
        <div class="dp-author">
          作者：
          <span v-for="item in i.author" :key="item">{{item}},</span>
        </div>
        <div class="dp-venue">会议/期刊：{{i.venue}}</div>
        <div class="dp-abstract">摘要：{{i.abstract}}</div>
      </div>
      <div class="dl-btn" v-if="!ismorepaper"> <el-button @click="morepaper">更多...</el-button></div>
    </div>
  </div>
</template>
<script>
import { getpaper, getlinechart, getproject } from "@/api/detail";
import { Chart } from "@antv/g2";
import * as echarts from "echarts";
import G6 from "@antv/g6";

export default {
  data() {
    return {
      tableData: [],
      keyword: "深度学习",
      count: 3,
      chart1year: [],
      chart1num: [],
      chart1money: [],
      chart2year: [],
      chart2fields:[],
      chart2series:[],
      metadata:[],
      paperlist:[],
      ismorely:false,
      ismorepaper:false
    };
  },
  //   components: {
  //     Map,
  //   },
  mounted() {
    this.keyword = this.$route.query.name;
    this.getdata();
  },
  methods: {
    getdata() {
      let params = {
        keyword: this.keyword,
        count: this.count,
      };
      getlinechart(params).then((res) => {
        this.chart1year = res.data.line_chart_1.year;
        this.chart1num = res.data.line_chart_1.num;
        this.chart1money = res.data.line_chart_1.money;
        this.initchart();

        let chart2fields = [];
        this.chart2fields = res.data.fields;
        this.chart2year = res.data.line_chart_2.year;
        for(let i=0;i<res.data.fields.length;i++){
          let name = res.data.fields[i];
          console.log(name,res.data.line_chart_2[name],'---61')
          chart2fields.push({
            name: name,
            type: "line",
            stack: "Total",
            smooth:true,
            data: res.data.line_chart_2[name],
          })
        }
        this.chart2series = chart2fields;
        this.initchart2();

        let params2 = {
          keyword:this.keyword,
          count:this.count,
          fields:this.chart2fields
        }
        getproject(params2).then((res) => {
          this.metadata = res.data
          console.log(this.metadata,'----81')
        });
      });
       getpaper(params).then((res) => {
         this.paperlist = res.data.related_literature;
      });
    },
    morely(){
      this.ismorely = true;
      let params2 = {
          keyword:this.keyword,
          count:20,
          fields:this.chart2fields
        }
        getproject(params2).then((res) => {
          this.metadata = res.data
          console.log(this.metadata,'----81')
        });
    },
    morepaper(){
      this.ismorepaper = true;
      let params2 = {
          keyword:this.keyword,
          count:20,
        }
        getpaper(params2).then((res) => {
          this.paperlist = res.data.related_literature
          console.log(this.metadata,'----81')
        });
    },
    initchart() {
      var chartDom = document.getElementById("dcmain1");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        // title: {
        //   text: 'Stacked Line'
        // },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["资助金额", "项目数"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chart1year,
        },
        yAxis: [
          {
            name: "万元",
            type: "value",
          },
          {
            name: "个",
            nameLocation: "start",
            alignTicks: true,
            type: "value",
            // inverse: true
          },
        ],
        series: [
          {
            name: "项目数",
            type: "line",
            stack: "Total",
            smooth: true,
            data: this.chart1num,
          },
          {
            name: "资助金额",
            yAxisIndex: 1,
            type: "line",
            stack: "Total",
            smooth: true,
            data: this.chart1money,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    initchart2() {


      var chartDom = document.getElementById("dcmain2");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: this.chart2fields,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chart2year,
        },
        yAxis: {
          type: "value",
        },
        series: this.chart2series,
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.detail-main {
  width: 100%;
  padding: 20px;
  overflow: hidden;
}
.detail-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
}
.detail-title img {
  width: 25px;
  vertical-align: middle;
  margin-top: -3px;
}
.detail-charts{
  width: 100%;
  overflow: hidden;
}
.dc-left {
  width: 50%;
  float: left;
}
.dc-right {
  width: 50%;
  float: right;
}
.dc-main {
  width: 100%;
  height: 500px;
}
.detail-ly{
  margin-top: 20px;
}
.dlip-span{
  display: inline-block;
  margin-right: 10px;
  font-size: 14px;
  span{
    font-weight: bold;
  }
}
.dlip-span-key{
  display: block;
  font-weight: bold;
  span{
    font-weight: 500;
  }
}
.dlip-title{
  font-weight: bold;
  font-size: 16px;
}
.dli-title{
  width: 100%;
  padding: 5px 15px;
  font-size: 17px;
  color:white;
  font-weight: bold;
  background-color: rgb(12, 56, 202);
  margin: 10px 0;
}
.dli-project{
  margin-bottom: 10px;
}
.detail-paperitem{
  margin-bottom: 10px;
  font-size: 14px;
}
.dp-title{
  font-weight: bold;
  font-size: 15px;
}
.detail-paper{
  margin-top: 20px;
}
.dl-btn{
  width: 100%;
  text-align: center;
}
.detail-name{
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.detail-ly-wrap{
  width: 100%;
  display: flex;
  // overflow: hidden;
}
.detail-ly-item{
  flex: 1;
  margin-right:15px ;
  // width: 32%;
  // margin-right: 1%;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/pages/nsfcdetail/index.vue